import type { Message } from '@efdigital/ll-addon-data';
import { findMessage } from '@efdigital/ll-admin-v2/data/builders/xceed/messages';
import type { ProgramsProgramCohortModel } from '@efdigital/ll-admin-v2/routes/programs/program/cohort';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type ParamsMessageId = {
  message_id: string;
};

export type ProgramsProgramCohortScheduleAnnouncementModel =
  ProgramsProgramCohortModel & {
    message_id: string;
    message: Message;
  };

export default class ProgramsProgramCohortScheduleAnnouncementRoute extends Route<ProgramsProgramCohortScheduleAnnouncementModel> {
  @service declare store: Store;

  async model(params: ParamsMessageId) {
    const parentModel = this.modelFor(
      'programs.program.cohort'
    ) as ProgramsProgramCohortModel;

    const response = await this.store.request(findMessage(params.message_id));
    const message = response.content.data;

    return {
      ...parentModel,
      message_id: params.message_id,
      message,
    };
  }
}
